import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';

const FIELD_MASKS = {
  'phone': (element: any) => {
    const length = element.value.trim().length;
    if (length <= 10) {
      return '00 0000 0000';
    } else if (length <= 12) {
      return '00 0000 00000';
    } else {
      return '00 00000 0000';
    }
  },
  'cpf': (element: any) => {
    if (element.value.trim().length <= 13)
      return '00.000.000-000';
    return '000.000.000-00';
  },
  'email': () => null
};


@Component({
  selector: 'app-search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.scss']
})
export class SearchDialogComponent implements OnInit {

  addCandidateForm: FormGroup;
  candidateToApprove: any;
  processListId: string = null;
  mediaEndpoint: string = 'https://app2.colloca.com.br/api';

  constructor(
    fb: FormBuilder,    
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: any,
    private processList: ProcessListService,
    private dialogRef: MatDialogRef<SearchDialogComponent> // Injete o MatDialogRef
  ){
    
    if (data) {
      this.processListId = data.processList.id;
    }

    this.addCandidateForm = fb.group({
      filterValue: [null, Validators.required],
      filterType: ['cpf', Validators.required]
    })

  }

  ngOnInit(): void {
  }

  submitAddCandidate() {

    if (this.addCandidateForm.valid) {

      const data = this.addCandidateForm.getRawValue();
      this.http.get('candidates:get_by', data)
        .subscribe(
          (result: any) => {
            //this.showAddCandidateForm = false;
            if (result)
              this.candidateToApprove = result;
            else
              this.snackbar.open('Candidato não encontrado!', 'OK', { duration: 3000 });
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  rejectCandidate() {
    this.candidateToApprove = null;
  }

  aproveCandidate() {
    const leads = [{ id: this.candidateToApprove.id }];
    
    this.http.save('process_list:lead', { leads, processList: this.processListId })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.candidateToApprove = null;
            const params = {
              leads,
              processList: this.processListId,
              action: 'selected'
            }

            this.http.save('process_list_action', params)
              .subscribe({
                error: err => this.errorReport.showMessage(err)
              })

            this.processList.clear(this.processListId);
            this.addCandidateForm.reset();
            // Feche o dialog após resetar o formulário
            this.dialogRef.close();

          }
        },
        err => this.errorReport.showMessage(err)
      )
  }

  getFieldMask(name: string, element: ElementRef<any>) {
    let fieldMask = FIELD_MASKS[name];
    if (fieldMask && typeof fieldMask === 'function') {
      return fieldMask(element);
    }
    return null;
  }

}
